import ReducerUtils   from "../../../utils/ReducerUtils"
import Actions        from "../../../model/constant/actions"

const RetrievingSpendAttempts = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_PACY_SPEND_ATTEMPTS] : (state,action)=>action.status
})

export default RetrievingSpendAttempts
